import { colors, makeStyles } from '@material-ui/core'
import palette from 'theme/palette'

const styles = makeStyles((theme) => ({
  chatMessageText: {
    color: 'black',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    fontWeight: 500,
  },
  daiIcon: {
    fill: 'currentColor',
    color: palette.dai.shinyBlue,
    width: '24px',
    height: '24px',
    display: 'block',
  },
  skeletonWave: {
    marginBottom: -7,
    backgroundColor: colors.lightBlue[50],
  },
}))

export default styles
